import React from 'react';
import {
	Container,
	Box,
	Grid,
	Paper,
	Divider,
	TableContainer,
	Table,
	TableHead,
	TableBody,
	TableRow,
	Avatar,
	withStyles,
	TableCell,
} from '@material-ui/core';
import BodyText from './BodyText';
import DashboardTable from './DashboardTable';
import { useSelector } from 'react-redux';
import TitleText from './TitleText';
const tableHeaders = [
	'ID',
	'ORDER_ID',
	'BOOKING_ID',
	'ORIGIN',
	'DESTINATION',
	'TRAVEL_DATE',
	'RETURN_DATE',
	'STATUS',
	'PAYABLE_AMOUNT',
];

const StyledTableCell = withStyles((theme) => ({
	head: {
		fontWeight: 600,
		color: '#8C8C8C',
		// padding: 3,
		fontSize: 16,
	},
	root: {
		borderBottom: 'none',
		paddingBottom: 0,
	},
}))(TableCell);
const BookingHistory = () => {
	const { bookinghistory, bookinghistoryagent } = useSelector(
		(state) => state.user
	);
	return (
		<>
			<Grid container spacing={2}>
				<Box>
					<TitleText
						four
						textStyle={{ fontFamily: 'Josefin Sans, sans-serif' }}>
						Booking History
					</TitleText>
				</Box>
				<Grid item xs={12}>
					<TableContainer style={{ marginTop: 15 }}>
						<Table>
							<TableHead>
								<TableRow>
									{tableHeaders.map((title, index) => (
										<StyledTableCell key={title}>{title}</StyledTableCell>
									))}
								</TableRow>
							</TableHead>
							<TableBody>
								{bookinghistory
									? bookinghistory &&
									  bookinghistory.result &&
									  bookinghistory.result.flights.length > 0 &&
									  bookinghistory.result.flights.map((item, index) => {
											return <DashboardTable item={item} rowIndex={index} />;
									  })
									: bookinghistoryagent
									? bookinghistoryagent &&
									  bookinghistoryagent.result &&
									  bookinghistoryagent.result.flights.length > 0 &&
									  bookinghistoryagent.result.flights.map((item, index) => {
											return <DashboardTable item={item} rowIndex={index} />;
									  })
									: ''}
							</TableBody>
						</Table>
					</TableContainer>
				</Grid>
			</Grid>
		</>
	);
};

export default BookingHistory;
